import { getCategoryMaintenance } from '@/api/product'

const maintenance = {
  state: {
    // 维保配件5级分类树形数据
    categoryMaintenanceList: []
  },
  mutations: {
    SET_CATEGORY_MAINTENANCE: (state, list) => {
      state.categoryMaintenanceList = list
    }
  },
  actions: {
    GetCategoryMaintenance({commit}) {
      return new Promise((resolve, reject) => {
        getCategoryMaintenance().then(response => {
          const list = (response && response.data) || []
          commit('SET_CATEGORY_MAINTENANCE', list)
          resolve(list)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default maintenance



// WEBPACK FOOTER //
// ./src/store/modules/maintenance.js